/* ============================================================
   SHINE & STYLE — collection filtering, sorting and search

   Works on any page containing [data-grid]. Cards carry their own
   data (data-tags, data-price, data-title), so nothing here needs a
   product feed and the same file serves collection and search.

   Filtering hides rather than removes, so sort order survives a
   filter change and nothing has to be re-rendered.
   ============================================================ */
(function () {
  'use strict';

  /* Every grid is wired independently and looks for its controls
     inside its own <main>. The shareable preview puts several pages
     in one document, so a document-wide query would bind the first
     grid's pills to every other page's products. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-grid]'), setup);

  function setup(grid) {
  var scope = grid.closest('main') || document;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.ss-card'));
  var countOut = scope.querySelector('[data-count-out]');
  var emptyMsg = scope.querySelector('[data-empty]');
  var pills = Array.prototype.slice.call(scope.querySelectorAll('[data-filter]'));
  var sortSel = scope.querySelector('[data-sort]');
  var searchInput = scope.querySelector('[data-search-input]');

  var state = { filter: '*', query: '' };

  function matches(card) {
    if (state.filter !== '*') {
      var tags = (card.getAttribute('data-tags') || '').toLowerCase();
      if (tags.split(/\s+/).indexOf(state.filter) === -1) return false;
    }
    if (state.query) {
      var hay = ((card.getAttribute('data-title') || '') + ' ' +
                 (card.getAttribute('data-tags') || '')).toLowerCase();
      if (hay.indexOf(state.query) === -1) return false;
    }
    return true;
  }

  function apply() {
    var shown = 0;

    cards.forEach(function (card) {
      var ok = matches(card);
      card.hidden = !ok;
      if (ok) {
        shown++;
        // A card revealed by a filter change has usually already been
        // passed by the scroll observer, so make sure it is visible.
        card.classList.add('is-in');
      }
    });

    if (countOut) {
      // The noun comes from the markup so the Arabic build can supply
      // its own; hardcoding it here left "19 pieces" on every RTL page.
      var one = countOut.getAttribute('data-label-one') || 'piece';
      var many = countOut.getAttribute('data-label') || 'pieces';
      countOut.textContent = shown + ' ' + (shown === 1 ? one : many);
    }
    if (emptyMsg) emptyMsg.hidden = shown !== 0;
    grid.hidden = shown === 0;
  }

  /* --- Filter pills --- */
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      state.filter = pill.getAttribute('data-filter') || '*';
      pills.forEach(function (p) {
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });
      apply();
    });
  });

  /* --- Sort ---
     Reordering the DOM keeps hidden cards in place, so switching the
     filter afterwards does not need a re-sort. */
  function sortBy(mode) {
    var sorted = cards.slice();

    if (mode === 'price-asc' || mode === 'price-desc') {
      sorted.sort(function (a, b) {
        var d = parseFloat(a.getAttribute('data-price') || 0) -
                parseFloat(b.getAttribute('data-price') || 0);
        return mode === 'price-asc' ? d : -d;
      });
    } else if (mode === 'title') {
      sorted.sort(function (a, b) {
        return (a.getAttribute('data-title') || '')
          .localeCompare(b.getAttribute('data-title') || '');
      });
    } else {
      sorted = cards.slice();   // 'featured' = original order
    }

    var frag = document.createDocumentFragment();
    sorted.forEach(function (c) { frag.appendChild(c); });
    grid.appendChild(frag);
  }

  if (sortSel) {
    sortSel.addEventListener('change', function () { sortBy(sortSel.value); });
  }

  /* --- Live search --- */
  if (searchInput) {
    var timer;
    searchInput.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        state.query = searchInput.value.trim().toLowerCase();
        apply();
      }, 140);
    });
  }

  /* --- Reset --- */
  Array.prototype.forEach.call(
    scope.querySelectorAll('[data-filter-reset]'),
    function (btn) {
      btn.addEventListener('click', function () {
        state.filter = '*';
        state.query = '';
        if (searchInput) searchInput.value = '';
        pills.forEach(function (p) {
          p.setAttribute('aria-pressed', p.getAttribute('data-filter') === '*' ? 'true' : 'false');
        });
        apply();
      });
    }
  );

  apply();
  }
})();
